<div class="container" style=" border: 1px solid #0076ce;margin-bottom: 5rem;">
  <h2 class="dds__h2" style="font-weight: bold; margin: 1rem;">Part Attachments
  </h2>
  <div style="margin: 1rem;">
    <div *ngIf="isLoading" style="margin: 4rem; display: flex; justify-content: center;">
      <svg style="height: 32px; width: 32px;">
        <use xlink:href="#dds__loading-sqrs"></use>
      </svg>
    </div>

    <div *ngIf="!isLoading && hasDownloadPrivilege && !dataEmpty && !errorLoading"
      class="fixTableHead dds__table-striped" style="margin: 1rem;overflow: auto; height: auto;
        min-height: 15vh; max-height: 35vh;">
      <table class="dds__table">
        <thead>

          <tr>
            <th>
              <input type="checkbox" class="dds__table-cmplx-select-all" title="select all rows" (change)="onCheckAll()"
                [checked]="checkMain">
            </th>
            <th>File Name</th>
            <th>File Description</th>
            <th>File Size</th>
            <th>File Type</th>
            <th>Folder Number</th>
            <th>Folder Version</th>
            <th>File Type Code</th>
            <th>File Destination</th>
          </tr>
        </thead>
        <tbody>
          <!-- <div *ngFor="let attachment of t.controls; let i = index"> -->
          <tr *ngFor="let partAttachment of partAttachments; let i = index">
            <!-- <ng-container [formGroup]="attachment" class="form-row"> -->
            <td><input type="checkbox" title="row select" value={{partAttachment.filename}}
                [checked]="partAttachment.fileSelected" (change)="onCheckboxChange(partAttachment)"></td>
            <td>
              <span>{{partAttachment.fileName}}</span>
            </td>
            <td>
              <span>{{partAttachment.fileDescription}}</span>
            </td>
            <td>
              <span>{{partAttachment.fileSize}}</span>
            </td>
            <td>
              <span>{{partAttachment.fileType}}</span>
            </td>
            <td>
              <span>{{partAttachment.folderNumber}}</span>
            </td>
            <td>
              <span>{{partAttachment.folderVersion}}</span>
            </td>
            <td>
              <span>{{partAttachment.fileTypeCode}}</span>
            </td>
            <td>
              <span>{{partAttachment.fileDestination}}</span>
            </td>
            <!-- </ng-container> -->
          </tr>
          <!-- </ng-container> -->
        </tbody>
      </table>

      <!-- </form> -->

    </div>
    <div *ngIf="!isLoading && !hasDownloadPrivilege">
      <p style="text-align: center; font-weight: bold;margin: 4rem;">No privilege</p>
    </div>
    <div *ngIf="!isLoading && dataEmpty">
      <p style="text-align: center; font-weight: bold;margin: 4rem;">No Attachments</p>
    </div>

    <div *ngIf="!isLoading && hasDownloadPrivilege && !dataEmpty && !errorLoading"
      style="display: flex; align-items: center; justify-content: center; margin: 2%;">
      <button [disabled]="hasDownloadPrivilege==false || rowSelected==false || replaceSectionVisible" role="button"
        type="button" class="dds__btn dds__btn-primary dds__text-truncate" style="margin-right: 1%;"
        (click)="onDownload()">Download</button>
      <button [disabled]="hasDownloadPrivilege==false || hasReplacePrivilege==false || rowSelected==false "
        role="button" type="button" class="dds__btn dds__btn-primary dds__text-truncate tooltip"
        data-toggle="dds__modal" data-target="#exampleModal" style="margin-right: 1%;"
        (click)="onClick('replaceSection');onReplace()">Replace<span class="tooltiptext">check-out,
          check-in</span></button>
      <button
        [disabled]="hasDownloadPrivilege==false || hasDeletePrivilege==false|| rowSelected==false || replaceSectionVisible"
        role="button" type="button" class="dds__btn dds__btn-primary dds__text-truncate"
        (click)="onDelete()">Delete</button>
    </div>
    <div *ngIf="!isLoading && errorLoading">
      <p style="text-align: center; font-weight: bold;margin: 4rem;color: var(--dell-red);">{{errorLoadingMsg}}</p>
    </div>

  </div>
</div>
<!-- The first div is used as a full screen background overlay. There are a few components that use this overlay so it only
   needs to be added once preferably at the top of the page below the body tag. This is a usable example. 

-->
<!-- 1 <div id="dds__full-screen-overlay" class="dds__overlay"></div>

<div id="exampleModal" tabindex="-1" class="dds__modal dds__fade" role="dialog" aria-labelledby="dds__modal-title">
<div class="dds__modal-dialog" role="document" style="top: 0;">
    <div class="dds__modal-content">
        <div class="dds__modal-header">
            <h3 class="dds__modal-title" id="dds__modal-title1">Replace Files</h3>
        </div>
        <button class="dds__close" data-dismiss="dds__modal" aria-label="Close">
            <span class="dds__icons dds__close-x" aria-hidden="true"></span>
        </button>
        <div class="dds__modal-body"> -->
<!-- <table data-table="dds__table2" class="dds__table dds__table-hover dds__table-cmplx dds__table-striped">
            <caption class="dds__sr-only">A Complex Tables
              <span>Table used to display Part Attachments</span>
            </caption>
          </table>
          <nav class="dds__pagination dds__pagination-justified-filter" data-toggle="dds__pagination" aria-label="pagination"></nav> -->
<!-- 1<div class="tableFixHead_add_row dds__table-striped" style="margin: 1rem;overflow: auto; height: 50vh;"> -->
<!-- <form [formGroup]="attachmentInfoDynamicForm"> -->
<!--1 <table class="dds__table">
                <thead>
    
                    <tr>
                        <th>File Name</th>
                        <th>File Type Code</th>
                        <th>Replace File</th>
                    </tr>
                </thead>
                <tbody> -->
<!-- <div *ngFor="let attachment of t.controls; let i = index"> -->
<!-- 1<tr *ngFor="let partAttachment of data_test; let i = index"> -->
<!-- <ng-container [formGroup]="attachment" class="form-row"> -->
<!-- <td>
                            <span>{{partAttachment.filename}}</span>
                        </td>
                        <td>
                          <span>{{partAttachment.fileTypeCode}}</span>
                        </td>
                        <td>
                          <button role="button" type="button" class="dds__btn dds__btn-secondary dds__btn-sm" style="color: black;" >Choose File</button>&nbsp;&nbsp;No File Chosen
                        </td> 1-->
<!-- </ng-container> -->
<!-- 1</tr> -->
<!-- </ng-container> -->
<!-- </tbody>
            </table> 1-->
<!-- </form> -->
<!-- </div>
        </div>
        <div class="dds__modal-footer">
            <button class="dds__btn dds__btn-secondary" data-dismiss="dds__modal">Close</button>
            <button class="dds__btn dds__btn-primary">Save changes</button>
        </div>
    </div>
</div>
</div>1 -->
<section id="replaceSection">
  <div *ngIf="replaceSectionVisible && t.controls != undefined && t.controls.length > 0" class="container"
    style=" border: 1px solid #0076ce;margin-bottom: 5rem;">
    <h2 class="dds__h2" style="font-weight: bold; margin: 1rem;">Replace Files
    </h2>
    <div style="margin: 1rem;">

      <div class="fixTableHead dds__table-striped" style="margin: 1rem;overflow: auto; height: auto;
        min-height: 15vh; max-height: 35vh;">
        <form [formGroup]="attachmentInfoDynamicForm">
          <table class="dds__table">
            <thead>

              <tr>
                <th>File Name</th>
                <th>File Type Code</th>
                <th>Replace File</th>
                <th style="text-align: center;">Digital Sign?</th>
              </tr>
            </thead>
            <tbody>
              <!-- <div *ngFor="let attachment of t.controls; let i = index"> -->
              <!-- <tr *ngFor="let partAttachment of getDetails(partAttachments); let i = index"> -->
              <ng-container *ngFor="let attachment of t.controls; let i = index">
                <tr>
                  <ng-container [formGroup]="attachment" class="form-row">
                    <td>
                      <!-- <span>{{partAttachment.fileName}}</span> -->
                      <span>{{attachment.value.fileName}}</span>
                    </td>
                    <td>
                      <span>{{attachment.value.fileTypeCode}}</span>
                    </td>
                    <td *ngIf="accToggleValue">
                      <!-- <app-file-explorer modalId="fileExplorerModal" modalTitleId="fileExplorerModalTitle" index={{i}} (fileNamePath)="enterFileName($event)"></app-file-explorer> -->
                      <!-- <app-file-explorer modalId="fileExplorerModal" modalTitleId="fileExplorerModalTitle" index={{i}} fileExtensions={{getFileExtension()}}  fileExtensionString={{getFileExtensionString()}} (fileNamePath)="enterFileName($event)"></app-file-explorer> -->
                      <app-file-explorer modalId="fileExplorerModal" modalTitleId="fileExplorerModalTitle" index={{i}}
                        fileExtensions={{getFileExtensionPartAtt(attachment.value.fileTypeCode)}}
                        fileExtensionString={{getFileExtensionStringPartAtt(attachment.value.fileTypeCode)}}
                        fileTypeCode={{attachment.value.fileTypeCode}}
                        (fileNamePath)="enterFileName($event)"></app-file-explorer>
                      <input formControlName="fileNameWithPath" type="text" placeholder="No file chosen" disabled />
                    </td>
                    <td *ngIf="!accToggleValue">
                      <input formControlName="fileNameWithPath" type="file" (change)="onFileChange($event,i)">
                    </td>
                    <td>
                      <div style="text-align: center;">
                        <input type="checkbox" name="digitalSign" formControlName="digitalSign">
                      </div>
                    </td>

                  </ng-container>
                </tr>
              </ng-container>
            </tbody>
          </table>
        </form>
        <!-- </form> -->
      </div>
    </div>
    <div style="display: flex; align-items: center; justify-content: center; margin: 2%;">
      <button role="button" type="button" class="dds__btn dds__btn-primary dds__text-truncate" style="margin-right: 1%;"
        (click)="onUpload()">Upload</button>
      <button role="button" type="button" class="dds__btn dds__btn-secondary dds__text-truncate"
        (click)="replaceSectionVisible = !replaceSectionVisible">Cancel</button>
    </div>
    <div *ngIf="uploadFilesError">
      <p style="margin-left: 1rem;margin-right: 1rem; color: var(--dell-red);">
        Validation Error:<br>
      </p>
    </div>
    <div *ngFor="let row of fileExtensionRowErr">
      <p style="margin-left: 1rem;margin-right: 1rem; color: var(--dell-red);">
        {{row}}
      </p>

    </div>
  </div>
</section>
<app-info-modal ng-init="expression" modalId="fromageId" modalTitleId="fromageTitle">
  <div modal-close>
    <button style="display:none" class="dds__close" id="closeModal" data-dismiss="dds__modal" aria-label="Close">
      <span class="dds__icons dds__close-x" aria-hidden="true"></span>
    </button>
  </div>
  <div modal-body>
    <div style="text-align: center;">
      <svg style="height: 32px; width: 32px; ">
        <use xlink:href="#dds__loading-sqrs"></use>
      </svg>
    </div>&nbsp;
    <p style="text-align: center;">{{loadingModalMessage}}</p>
  </div>
  <span modal-trigger id="progressbar">
  </span>
</app-info-modal>